<template>
  <b-container fluid class="no-sided-margin">
    <div style="padding-top: 10px">
      <b-alert :show="showAlert" dismissible @dismissed="showAlert = false">
        Visualizza l'elenco dei Punti di Vendita DAO, e consente l'aggiunta o l'aggiornamento di un Punto Vendita.
      </b-alert>
    </div>
    <b-row class="margin-top-md margin-bottom-md">
      <b-col cols="3">
        <b-card header-bg-variant="light">
          <template #header>
            <div class="custom-card-header">
              <strong>
                <b-icon-funnel></b-icon-funnel>
                Nuovo Negozio</strong>
            </div>
          </template>
          <b-card-body style="padding: 0.5rem">
            <b-form-row>
              <b-form-group class="col-lg-12 col-md-12">
                <b-button-group>
                  <b-button disabled><b-icon-search/></b-button>
                  <b-form-input
                    @update="searchShop"
                    placeholder="cerca">
                  </b-form-input>
                </b-button-group>
              </b-form-group>

              <b-button block title="Aggiungi il negozio" v-b-tooltip.hover variant="primary" ref="note" v-b-modal.shop @click="newShop()">
                <b-icon-plus/>&nbsp;Aggiungi Negozio
              </b-button>
              <b-button @click="exportCsv" :disabled="isDownloading" variant="success" block >
                <b-spinner small v-show="isDownloading"></b-spinner>
                <b-icon-arrow-bar-down/>&nbsp;Download csv
              </b-button>
            </b-form-row>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col cols="9">
        <b-card header-bg-variant="light">
          <template #header>
            <div style="height: 1.5rem">
              <span><strong><b-icon-card-checklist/>&nbsp;Negozi trovati</strong></span>
            </div>
          </template>
          <b-card-body>
            <b-table sticky-header="82vh" :no-border-collapse="true" responsive :fields="fields" :items="searchedShops" class="cap-smalled">
              <template #cell(city)="data">
                <span>{{ data.item.city }} ({{ data.item.province }}), {{ data.item.street }}, {{ data.item.postalCode }}</span>
              </template>
              <template #cell(contacts)="data">
                <span>{{ data.item.email }}</span>
                <br/>
                <span>{{ data.item.phoneNumber }}</span>
              </template>
              <template #cell(actions)="data">
                <b-button size="sm" title="Modifica il negozio" v-b-tooltip.hover variant="success" ref="note" v-b-modal.shop @click="editShop(data.item)">
                  <b-iconstack>
                    <b-icon stacked icon="file"></b-icon>
                    <b-icon stacked icon="pencil-fill" scale="0.8" shift-h="5" shift-v="1"></b-icon>
                  </b-iconstack>
                </b-button>
              </template>
            </b-table>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <Shop :shop="currentShop" :eventName="eventName" @shop-added="addShop" @shop-modified="modifyShop"/>
    <div style="float: right">
      <p style="font-size: 11px">Powered by <img width="100px" src="../assets/CherryChainLogo.png" alt="CherryChain"></img></p>
    </div>
  </b-container>
</template>

<script>

import ShopsApi from "../api/ShopsApi";
import Shop from "../components/shops/Shop.vue";
import MiniSearch from "minisearch";
import eventBus from "@/EventBus";

let miniSearch = new MiniSearch({
  fields: ['code', 'name', 'city'],
  storeFields: ['code', 'name', 'city', 'province', 'street', 'postalCode', 'email', 'phoneNumber', 'vatCode'],
  searchOptions: {
    prefix: true
  }
})

export default {
  name: 'Shops',
  components: { Shop },
  provide() {
    return {parentValidator: this.$validator}
  },
  mounted () {
    eventBus.$on("show-alert", () => this.showAlert = true)
    this.findShops()
  },
  data: () => ({
    showAlert: false,
    fields: [
      { key: 'code', label: 'Codice', sortable: true },
      { key: 'name', label: 'Ragione Sociale', sortable: true },
      { key: 'city', label: 'Città', sortable: true },
      { key: 'contacts', label: 'Contatti', sortable: true },
      { key: 'vatCode', label: 'P.IVA', sortable: true },
      { key: 'actions', label: '' }
    ],
    shops: [],
    searchedShops: [],
    shop: {},
    currentShop: null,
    eventName: "shop-added",
    isDownloadingStats: false
  }),
  methods: {
    findShops() {
      ShopsApi.all().then(result => {
        this.shops = result
        this.searchedShops = this.shops
        miniSearch.addAll(this.searchedShops)
      })
    },
    newShop() {
      this.eventName = "shop-added"
      this.currentShop = null
    },
    editShop(item) {
      this.eventName = "shop-modified"
      this.currentShop = item
    },
    addShop(event) {
      ShopsApi.add(event)
        .then(() => this.makeToast('success', 'Aggiunta dei dati del negozio eseguita correttamente'))
        .catch(() => this.makeToast('danger', 'Aggiunta dei dati del negozio NON riuscita!'))
        .finally(() => {
          this.$bvModal.hide('shop')
          this.findShops()
        })
    },
    modifyShop(event) {
      ShopsApi.modifyShop(this.currentShop.code, event)
        .then(() => this.makeToast('success', 'Modifica dei dati del negozio eseguita correttamente'))
        .catch(() => this.makeToast('danger', 'Modifica dei dati del negozio NON riuscita!'))
        .finally(() => {
          this.$bvModal.hide('shop')
          this.findShops()
        })
    },
    searchShop(text) {
      if (text === '') this.searchedShops = this.shops
      else this.searchedShops = miniSearch.search(text)
    },
    makeToast(type, message) {
      this.$bvToast.toast(message, {
        title: 'Negozio',
        variant: type,
        toaster: 'b-toaster-top-center',
        solid: true
      })
    },
    exportCsv() {
      this.isDownloading = true
      ShopsApi
        .downloadCsv()
        .finally(() => { this.isDownloading = false })
    }
  }
}


</script>

<style>
#status-dropdown > .dropdown-menu.show {
  background-color: white;
  background-image: unset;
}

.popover {
  max-width: 500px !important;
}

</style>
